import { Component, ojs, app } from "modular-openscriptjs";
import BsIcon from "./BsIcon";

const h = app("h");

ojs(BsIcon);

export default class SearchIconBtn extends Component {
    render(...args) {
        return h.a(
            {
                class: "d-none d-md-inline-block btn btn-outline-primary border-transparent position-relative nav-auth-btn",
                type: "button",
                onclick: h.func(`app('router').to`, "app.search"),
            },
            h.BsIcon("search"),
            ...args,
        );
    }
}

ojs(SearchIconBtn);
